/**
 * Created by qing on 2019/1/16.
 */
export default {
  // baseUrl: "http://192.168.1.227:8066",
  baseUrl: "/apis/",
  // baseUrl: "http://192.168.1.217:8081/apis",
  //baseImgUrl: "http://192.168.1.217:81",      //测试
   baseImgUrl: "http://lgw.china-price.com.cn:80/",   //准正式
  // baseUrl: "http://192.168.14.115:8081/",
  // baseUrl: "http://192.168.2.118:8082/apis", //本地接口
  navList:[

    {
      top:'1',
      left:[
        {
          index:'1-1',
          name:'入会管理',
          icon:'el-icon-tickets',
          childrens:[
            {
              index:'1-1-1',
              name:'入会申请',
              url:'/applymember'
            },
            {
              index:'1-1-2',
              name:'信息展示',
              url:'/infodisplay'
            },
            {
              index:'1-1-3',
              name:'信息变更记录',
              url:'/infochangerecord'
            },
            {
              index:'1-1-4',
              name:'业务量上报',
              url:'/bizduesreport'
            },
            {
              index:'1-1-5',
              name:'会费续缴',
              url:'/membershiprenewal'
            }
          ]
        },
        {
          index:'1-2',
          name:'证件办理',
          icon:'el-icon-document',
          childrens:[
            {
              index:'1-2-1',
              name:'证件办理',
              url:'/handlecertificate'
            }
          ]
        },
        {
          index:'1-3',
          name:'缴费管理',
          icon:'el-icon-goods',
          childrens:[
            {
              index:'2-3-1',
              name:'会费审批',
              url:'/paymentapprovalhy'
            },
            {
              index:'2-3-2',
              name:'培训费审批',
              url:'/paymenttrainingapprovalhy'
            }/*,
            {
              index:'1-3-1',
              name:'缴费记录',
              url:'/membershipdues'
            },
            {
              index:'1-3-2',
              name:'培训费缴纳',
              url:'/trainningfee'
            }*/
          ]
        },
        {
          index:'1-4',
          name:'培训管理',
          icon:'el-icon-news',
          childrens:[
            {
              index:'1-4-1',
              name:'培训报名',
              url:'/trainApply'
            },
            {
              index:'1-4-2',
              name:'培训人员查询',
              url:'/trainperson'
            }
            // {
            //   index:'1-4-3',
            //   name:'证书收取',
            //   url:'/chargecertificate'
            // }
          ]
        },
        {
          index:'1-5',
          name:'信息管理',
          icon:'el-icon-message',
          childrens:[
            {
              index:'1-5-1',
              name:'会员展示编辑',
              url:'/memberdisplayeditor'
            },
            {
              index:'1-5-2',
              name:'安全管理',
              url:'/mysafety'
            },
            {
              index:'1-5-3',
              name:'意见反馈',
              url:'/advicefeedback'
            }
          ]
        }
        // {
        //   index:'1-6',
        //   name:'考试报名',
        //   icon:'el-icon-bell',
        //   childrens:[
        //     {
        //       index:'1-6-1',
        //       name:'在线报名',
        //       url:'/testregister'
        //     },
        //     {
        //       index:'1-6-2',
        //       name:'成绩查询',
        //       url:'/undefined/51'
        //     },
        //     {
        //       index:'1-6-3',
        //       name:'转考证打印',
        //       url:'/undefined/52'
        //     },
        //     {
        //       index:'1-6-4',
        //       name:'考试政策',
        //       url:'/undefined/53'
        //     }
        //   ]
        // }
      ]
    },
    {
      top:'2',
      left:[
        {
          index:'2-1',
          name:'机构管理',
          icon:'el-icon-tickets',
          childrens:[
            {
              index:'/memberapproval',
              name:'入会审批',
              url:'/memberapproval'
            },
            {
              index:'/changeapproval',
              name:'变更审批',
              url:'/changeapproval'
            },
            {
              index:'2-1-3',
              name:'机构会员查询',
              url:'/organizationmember'
            },
            {
              index:'2-1-4',
              name:'个人会员查询',
              url:'/personalmember'
            },
            {
              index:'1-1-5',
              name:'机构续缴会费审核',
              url:'/renewalContributions'
            },
            {
              index:'1-1-6',
              name:'机构业务量查看',
              url:'/businessstatistics'
            }
          ]
        },
        {
          index:'2-2',
          name:'证件办理管理',
          icon:'el-icon-document',
          childrens:[
            {
              index:'2-2-1',
              name:'证件初审',
              url:'/certificateapproval'
            },
            {
              index:'2-2-2',
              name:'证件办理',
              url:'/certificatehandle'
            },
            {
              index:'2-2-3',
              name:'邮寄证件',
              url:'/certificatepost'
            },
            {
              index:'2-2-4',
              name:'办结证件',
              url:'/certificatefinish'
            }
          ]
        },
        {
          index:'2-3',
          name:'缴费管理',
          icon:'el-icon-goods',
          childrens:[
            {
              index:'2-3-1',
              name:'会费审批',
              url:'/paymentapproval'
            },
            {
              index:'2-3-2',
              name:'培训费审批',
              url:'/paymenttrainingapproval'
            }
            // {
            //   index:'2-3-3',
            //   name:'缴费统计',
            //   url:'/paymentstatistics'
            // }
          ]
        },
        {
          index:'2-4',
          name:'培训管理',
          icon:'el-icon-news',
          childrens:[
            {
              index:'2-4-1',
              name:'培训活动列表',
              url:'/trainingactivity'
            },
            {
              index:'2-4-2',
              name:'培训报名审核',
              url:'/registrationexamination'
            },
            {
              index:'2-4-3',
              name:'培训证书打印',
              url:'/trainingcertificateprint'
            },
            {
              index:'2-4-4',
              name:'培训证书邮寄',
              url:'/trainingcertificatepost'
            },
            {
              index:'2-4-5',
              name:'历史培训人员',
              url:'/trainingHistoryTrainers'
            }
          ]
        },
        // {
        //   index:'2-5',
        //   name:'考试报名管理',
        //   icon:'el-icon-bell',
        //   childrens:[
        //     {
        //       index:'2-5-1',
        //       name:'考试信息管理',
        //       url:'/exammanage'
        //     },
        //     {
        //       index:'2-5-2',
        //       name:'考试报名设置',
        //       url:'/undefined/2'
        //     },
        //     {
        //       index:'2-5-3',
        //       name:'考试报名查询',
        //       url:'/undefined/3'
        //     },
        //     {
        //       index:'2-5-4',
        //       name:'考试成绩录入',
        //       url:'/undefined/4'
        //     }
        //   ]
        // },
        {
          index:'2-6',
          name:'系统管理',
          icon:'el-icon-setting',
          childrens:[
            {
              index:'2-6-1',
              name:'用户管理',
              url:'/usermanage'
            },
            {
              index:'2-6-2',
              name:'角色管理',
              url:'/rolemanage'
            },
            // {
            //   index:'2-6-3',
            //   name:'部门管理',
            //   url:'/departmentmanage'
            // },
            // {
            //   index:'2-6-4',
            //   name:'流程管理',
            //   url:'/workflowmanage'
            // }
          ]
        }
      ]
    },
    {
      top:'3',
      left:[
        {
          index:'3-0',
          name:'轮播图设置',
          icon:'el-icon-menu',
          url:'/slideshow',
          childrens:[]
        },
        {
          index:'3-1',
          name:'分会动态',
          icon:'el-icon-menu',
          url:'/branchdynamic',
          childrens:[]
        },
        {
          index:'3-2',
          name:'行业资讯',
          icon:'el-icon-tickets',
          url:'/industrynews',
          childrens:[]
        },
        {
          index:'3-3',
          name:'会刊展示',
          icon:'el-icon-document',
          url:'/proceedingmanage',
          childrens:[]
        },
        {
          index:'3-4',
          name:'通知公告',
          icon:'el-icon-goods',
          url:'/noticemanage',
          childrens:[]
        },
        {
          index:'3-5',
          name:'会员展示',
          icon:'el-icon-sold-out',
          url:'/memberdisplay',
          childrens:[]
        },
        {
          index:'3-6',
          name:'特色案例',
          icon:'el-icon-news',
          url:'/specialcase',
          childrens:[]
        },
        {
          index:'3-7',
          name:'疑难案件委托',
          icon:'el-icon-message',
          number:'4',
          url:'/lawyercorpus',
          childrens:[]
        },
        {
          index:'3-8',
          name:'分会介绍',
          icon:'el-icon-view',
          url:'/branchintroduce',
          childrens:[]
        },
        {
          index:'3-9',
          name:'高法推荐设置',
          icon:'el-icon-setting',
          url:'/courtrecommend',
          childrens:[]
        },
        {
          index:'3-10',
          name:'行业法规',
          icon:'el-icon-bell',
          url:'/lawsregulations',
          childrens:[]
        },
        {
          index:'3-11',
          name:'意见反馈管理',
          icon:'el-icon-share',
          url:'/feedbackmanage',
          childrens:[]
        }
      ]
    },
    {
      top:'5',
      left:[
        /*{
          index:'5-1',
          name:'高发视窗',
          icon:'el-icon-menu',
          childrens:[
            {
              index:'5-1-1',
              name:'机构推荐查看',
              url:'/jigoutuijianchakan'
            },
            {
              index:'5-1-2',
              name:'机构查询',
              url:'/jigouchaxun'
            },
            {
              index:'5-1-3',
              name:'会员查询',
              url:'/huiyuanchaxun'
            }
          ]
        }*/
        {
          index:'5-1',
          name:'机构推荐查看',
          icon:'el-icon-menu',
          url:'/orgrecommended',
          childrens:[]
        },
        {
          index:'5-2',
          name:'机构查询',
          icon:'el-icon-news',
          url:'/agencyquery',
          childrens:[]
        },
        {
          index:'5-3',
          name:'会员查询',
          icon:'el-icon-search',
          url:'/memberquery',
          childrens:[]
        }
      ]
    }

  ],
  ueditorToolbar:[[
    'bold', 'italic', 'underline' ,'|',
    'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'fontborder','|',
    'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
    'customstyle', 'paragraph','fontfamily', 'fontsize','|',
    'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow',
    'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', 'insertimage']]
}




// WEBPACK FOOTER //
// ./src/config.js